import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // f
  .init({
    debug: process.env.NODE_ENV !== "production",
    lng: localStorage.getItem("i18nextLng"),
    fallbackLng: "gu",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          title: "Darji Point",
          nav: {
            dashboard: "Dashboard",
            customer: "Customer",
            worker: "Worker",
            debt: "Debt",
            expense: "Expense",
            whatsapp: "Whatsapp",
            logout: "Log out",
          },
          dashboard: {
            title: "Dashboard",
            todayOrders: "Today's Orders",
            monthRevenue: "This Month Revenue",
            pendingToday: "Due Today",
            overdue: "Overdue",
            pendingPayments: "Pending Payments",
            totalOrders: "This Month Orders",
            ordersByStatus: "Orders by Status",
            recentOrders: "Recent Orders",
            monthlyRevenue: "Monthly Revenue",
            recordPayment: "Record Payment",
            amountReceived: "Amount received",
            recordBtn: "Record",
            orderVolume: "Order Volume (30 Days)",
            garmentMix: "Garment Mix",
            deliveryPipeline: "Delivery Pipeline",
            topCustomers: "Top Customers",
            workerWorkload: "Worker Workload",
            activityFeed: "Activity Feed",
          },
          status: {
            RECEIVED: "Received",
            CUTTING: "Cutting",
            STITCHING: "Stitching",
            READY: "Ready",
            DELIVERED: "Delivered",
          },
          common: {
            login: "Login",
            language: "Language",
            username: "username",
            password: "password",
            clickMe: "Click me",
            name: "Name",
            address: "Address",
            billNo: "Bill No",
            number: "No",
            date: "Date",
            mobile: "Mobile",
            shirt: "Shirt",
            pant: "Pant",
            save: "Save",
            clear: "Clear",
            find: "Find",
            to: "To",
            total: "Total",
            loading: "Please wait...",
            measurement: "Measurement",
            type: "Type",
            pocket: "Pocket",
            style: "Style",
            options: "Options",
            count: "count",
            details: "Details",
            amount: "₹",
            advance: "Advance",
            delieveryDate: "Delivery Date",
            sendMessage: "Send Message",
            all: "All",
            add: "Add details",
            search: "Search",
            logWork: "Log Work",
            workReport: "Work Report",
            debt: "Debt",
            report: "Report",
            actions: "Actions",
            delete: "Delete",
            update: "Update",
            message: "Message",
            print: "Print",
            download: "Download",
            yes: "Yes",
            no: "No",
            deleteConfirmation: "Are you sure??",
            startDate: "Start date",
            endDate: "End Date",
            confirmDelete: "Are you sure???",
            clothAdvance: "Kapad Na Baki",
            cancle: "Cancle",
            printInvoice: "Print Invoice",
            qty: "Qty.",
            generateBill: "Generate Bill",
            required: "Required",
            noData: "No Data Found",
            welcome: "Welcome to Darji Point",
            viewMeasure: "View Measurement",
            errorMessage:
              "Enter the valid data or Check your internet connection",
            exit: "Logged out successfully",
            whatsappMessage: "Send Whatsapp Message",
            phoneValidation: "Enter Valid Mobile Number",
            allRecords: "All Records",
            prev: "Prev",
            next: "Next",
            draftRestored: "Restored your unsaved order draft",
            emptyGarment: "Enter measurements or a count for pant or shirt",
          },
          error: {
            shirtOrPant: "Select either shirt or pant first",
          },
          pant: {
            type: {
              pant: "Pant",
              halfRubberPant: "Half Rubber Pant",
              jeans: "Jeans",
              cottonJeans: "Cotton Jeans",
              chudidarFartuRubber: "Chudidar Fartu Rubber",
            },
            options: {
              grip: "Grip",
              fittingShape: "Fitting Shape",
              singleSilai: "Single Silai",
              doubleSilai: "Double Silai",
              hathSilai: "Sandha Chirine - Hath Silai",
              moliSilai: "Sandha Chirine - Molima Silai",
              gajButtonChorasBelt: "Gaj Button Choras Belt",
            },
          },
          shirt: {
            type: {
              open: "Open",
              bushart: "Bushirt",
              shortShirt: "Short Shirt",
              openKurto: "Open Kurto",
              kurto: "Kurto",
              jabbho: "Jabbho",
              safari: "Safari",
              sherwani: "Sherwani",
              koti: "Koti",
              suit: "Suit",
              blazzer: "Blazzer",
              indoWestern: "Indo Western",
              hineckKurto: "Hi-neck Kurto",
            },
            options: {
              uparPocket: "Open Pocket",
              andarBaharPocket: "Andar-Bahar Pocket",
              sadaPocket: "Sada(2) Pocket",
              cutPocket: "Cut Pocket",
              uparPatti: "Upar Patti",
              chineseColar: "Chinese Colar",
              colorOneInch: "Collar 1 || inch",
              fancyButton: "Fancy Button",
              ringButton: "Ring Button",
              noPocket: "No Pocket",
              logoTanki: "Logo Tanki",
              pachadDarts: "Pachad Darts",
              pocket2: "Pocket(2) Dhaknawala",
              pocket1: "Pocket(1) Dhaknawala",
              gajButton: "Buy-Patti Gaj Button",
              foldPatti: "Fold Patti",
              halfBuy: "Half Buy",
            },
          },
        },
      },
      gu: {
        translation: {
          title: "દરજી પોઇન્ટ",
          nav: {
            dashboard: "ડૅશબોર્ડ",
            customer: "ગ્રાહક",
            worker: "કારીગર",
            expense: "ખર્ચ",
            whatsapp: "વ્હાટ્સએપ",
            logout: "લોગ આઉટ",
          },
          dashboard: {
            title: "ડૅશબોર્ડ",
            todayOrders: "આજ ના ઓર્ડર",
            monthRevenue: "આ મહિના ની આવક",
            pendingToday: "આજ ની ડિલિવરી",
            overdue: "મોડી ડિલિવરી",
            pendingPayments: "બાકી ચૂકવણી",
            totalOrders: "આ મહિના ના ઓર્ડર",
            ordersByStatus: "સ્ટેટસ પ્રમાણે ઓર્ડર",
            recentOrders: "તાજેતર ના ઓર્ડર",
            monthlyRevenue: "માસિક આવક",
            recordPayment: "ચુકવણી નોંધો",
            amountReceived: "મળેલી રકમ",
            recordBtn: "નોંધો",
            orderVolume: "ઓર્ડર (૩૦ દિવસ)",
            garmentMix: "ગારમેન્ટ મિક્સ",
            deliveryPipeline: "ડિલિવરી પાઇપલાઇન",
            topCustomers: "ટોપ ગ્રાહકો",
            workerWorkload: "કારીગર નું કામ",
            activityFeed: "તાજેતરની પ્રવૃત્તિ",
          },
          status: {
            RECEIVED: "મળ્યો",
            CUTTING: "કટિંગ",
            STITCHING: "સિલાઈ",
            READY: "તૈયાર",
            DELIVERED: "ડિલિવર",
          },
          common: {
            login: "લોગીન કરો",
            language: "ભાષા",
            username: "નામ",
            password: "પાસવર્ડ",
            clickMe: "અહીંયા ક્લિક કરો",
            laoding: "રાહ જોવો....",
            name: "નામ",
            address: "સરનામું",
            billNo: "બિલ નંબર",
            number: "નંબર",
            date: "તારીખ",
            mobile: "મોબાઈલ",
            shirt: "શર્ટ",
            pant: "પેન્ટ",
            save: "માહિતી સાચવો",
            clear: "માહિતી સાફ કરો",
            find: "શોધો",
            to: "થી",
            total: "ટોટલ",
            loading: "રાહ જોવો...",
            measurement: "માપ",
            type: "પ્રકાર",
            pocket: "ખિસ્સું",
            style: "સ્ટાઈલ",
            options: "વિકલ્પ",
            count: "નંગ",
            details: "વિગત",
            amount: "₹",
            advance: "જમા ",
            delieveryDate: "ડિલિવરી તારીખ",
            sendMessage: "મેસેજ મોકલો",
            all: "બધા",
            add: "નવી માહિતી",
            logWork: "કામ નાખો",
            workReport: "કામ નો રિપોર્ટ",
            debt: "ઉપાડ",
            report: "રિપોર્ટ",
            search: "શોધ",
            actions: "માહિતી કાઢો/સુધારો",
            delete: "માહિતી કાઢો",
            update: "માહિતી સુધારો",
            message: "મેસેજ",
            print: "પ્રિન્ટ નીકળો",
            download: "ડાઉનલોડ કરો",
            yes: "હા",
            no: "ના",
            deleteConfirmation: "કરો શું તમે માહિતી ડીલીટ કરવા માન્ગો છો?",
            startDate: "શરુ તારીખ",
            endDate: "પુરી તારીખ",
            confirmDelete: "શું તમે ખરેખર માહિતી ડીલીટ કરવા માન્ગો છો?",
            clothAdvance: "કાપડ ના બાકી",
            cancle: "સાફ કરો",
            printInvoice: "બિલ પ્રિન્ટ કરો",
            qty: "નંગ",
            generateBill: "બિલ નીકાલો",
            required: "જરૂરી માહિતી",
            noData: "કોઈ માહિતી મળી નથી",
            welcome: "દરજી પોઇન્ટ માં આપ નું સ્વાગત છે",
            viewMeasure: "માપ જોવો",
            errorMessage: "પૂરતો ડેટા નાખો અથવા તમારું ઈન્ટરનેટ ચકાસો",
            exit: "લોગ આઉટ કરેલ છે",
            whatsappMessage: "વ્હાટ્સએપ મેસેઝ મોકલો",
            phoneValidation: "મોબાઇલ નંબર ચકાસો",
            allRecords: "બધા રેકોર્ડ",
            prev: "પાછળ",
            next: "આગળ",
            draftRestored: "તમારો સાચવેલ ડ્રાફ્ટ પાછો મળ્યો",
            emptyGarment: "પેન્ટ અથવા શર્ટ નું માપ અથવા નંગ ભરો",
          },
          error: {
            shirtOrPant: "શર્ટ અથવા પંત સિલેક્ટ કરો",
          },
          pant: {
            type: {
              pant: "પેન્ટ",
              halfRubberPant: "હાલ્ફ રબર પેન્ટ",
              jeans: "જીન્સ",
              cottonJeans: "કોટન જીન્સ",
              chudidarFartuRubber: "ચુડીદાર ફરતું રબર",
            },
            options: {
              grip: "ગ્રીપ",
              fittingShape: "ફિટિંગ શેપ",
              singleSilai: "સિંગલ સિલાઈ",
              doubleSilai: "ડબલ સિલાઈ",
              hathSilai: "સાંધા ચીરીને - હાથ સિલાઈ",
              moliSilai: "સાંધા ચીરીને - મોળીમાં સિલાઈ",
              gajButtonChorasBelt: "ગાજ-બટન ચોરસ બેલ્ટ",
            },
          },
          shirt: {
            type: {
              open: "ઓપન",
              bushart: "બુશર્ટ",
              shortShirt: "શોર્ટ શર્ટ",
              openKurto: "ઓપન કુર્તો",
              kurto: "કુર્તો",
              jabbho: "ઝભ્ભો",
              safari: "સફારી",
              sherwani: "શેરવાની",
              koti: "કોટી",
              suit: "શૂટ",
              blazzer: "બ્લેઝર",
              indoWestern: "ઈન્ડો વેસ્ટર્ન",
              hineckKurto: "હાઈનેક કુર્તો",
            },
            options: {
              uparPocket: "ઉપર પોકેટ",
              andarBaharPocket: "અંદર-બહાર પોકેટ",
              sadaPocket: "સાદા(૨) પોકેટ",
              cutPocket: "કટ પોકેટ",
              uparPatti: "ઉપર પટ્ટી",
              chineseColar: "ચાઇનીસ કોલર",
              colorOneInch: "કોલર ૧|| ઇંચ",
              fancyButton: "ફેંસી બટન",
              ringButton: "રિંગ બટન",
              noPocket: "નો પોકેટ",
              logoTanki: "લોગો ટાંકી",
              pachadDarts: "પાછળ ડાર્ટ્સ",
              pocket2: "પોકેટ(૨) ઢાંકણાવાળા",
              pocket1: "પોકેટ(૧) ઢાંકણાવાળા",
              gajButton: "બાઇપટ્ટી ગાજ-બટન",
              foldPatti: "ફોલ્ડ પટ્ટી",
              halfBuy: "હાલ્ફ બાય",
            },
          },
        },
      },
      hi: {
        translation: {
          title: "दरजी पॉइंट",
          nav: {
            dashboard: "डैशबोर्ड",
            customer: "ग्राहक",
            worker: "कारीगर",
            expense: "खर्च",
            whatsapp: "व्हाट्सएप",
            logout: "लॉग आउट",
          },
          dashboard: {
            title: "डैशबोर्ड",
            todayOrders: "आज के ऑर्डर",
            monthRevenue: "इस महीने की आय",
            pendingToday: "आज की डिलीवरी",
            overdue: "देर से डिलीवरी",
            pendingPayments: "बाकी भुगतान",
            totalOrders: "इस महीने के ऑर्डर",
            ordersByStatus: "स्टेटस अनुसार ऑर्डर",
            recentOrders: "हालिया ऑर्डर",
            monthlyRevenue: "मासिक आय",
            recordPayment: "भुगतान दर्ज करें",
            amountReceived: "प्राप्त राशि",
            recordBtn: "दर्ज करें",
            orderVolume: "ऑर्डर (30 दिन)",
            garmentMix: "गारमेंट मिक्स",
            deliveryPipeline: "डिलीवरी पाइपलाइन",
            topCustomers: "टॉप ग्राहक",
            workerWorkload: "कारीगर का काम",
            activityFeed: "हालिया गतिविधि",
          },
          status: {
            RECEIVED: "मिला",
            CUTTING: "कटिंग",
            STITCHING: "सिलाई",
            READY: "तैयार",
            DELIVERED: "दिया",
          },
          common: {
            login: "लॉगिन करें",
            language: "भाषा",
            username: "यूज़रनेम",
            password: "पासवर्ड",
            clickMe: "यहाँ क्लिक करें",
            name: "नाम",
            address: "पता",
            billNo: "बिल नंबर",
            number: "नंबर",
            date: "तारीख",
            mobile: "मोबाइल",
            shirt: "शर्ट",
            pant: "पेंट",
            save: "सेव करें",
            clear: "साफ़ करें",
            find: "खोजें",
            to: "से",
            total: "कुल",
            loading: "कृपया प्रतीक्षा करें...",
            measurement: "माप",
            type: "प्रकार",
            pocket: "जेब",
            style: "स्टाइल",
            options: "विकल्प",
            count: "नग",
            details: "विवरण",
            amount: "₹",
            advance: "जमा",
            delieveryDate: "डिलीवरी तारीख",
            sendMessage: "मैसेज भेजें",
            all: "सभी",
            add: "नई जानकारी",
            search: "खोज",
            logWork: "काम डालें",
            workReport: "काम की रिपोर्ट",
            debt: "उधार",
            report: "रिपोर्ट",
            actions: "कार्रवाई",
            delete: "डिलीट करें",
            update: "अपडेट करें",
            message: "मैसेज",
            print: "प्रिंट करें",
            download: "डाउनलोड करें",
            yes: "हाँ",
            no: "नहीं",
            deleteConfirmation: "क्या आप वाकई जानकारी डिलीट करना चाहते हैं?",
            startDate: "शुरू तारीख",
            endDate: "अंत तारीख",
            confirmDelete: "क्या आप वाकई जानकारी डिलीट करना चाहते हैं?",
            clothAdvance: "कपड़ा बाकी",
            cancle: "रद्द करें",
            printInvoice: "बिल प्रिंट करें",
            qty: "नग",
            generateBill: "बिल बनाएं",
            required: "आवश्यक जानकारी",
            noData: "कोई जानकारी नहीं मिली",
            welcome: "दरजी पॉइंट में आपका स्वागत है",
            viewMeasure: "माप देखें",
            errorMessage: "सही जानकारी डालें या अपना इंटरनेट जांचें",
            exit: "लॉग आउट हो गया",
            whatsappMessage: "व्हाट्सएप मैसेज भेजें",
            phoneValidation: "सही मोबाइल नंबर डालें",
            allRecords: "सभी रिकॉर्ड",
            prev: "पिछला",
            next: "अगला",
            draftRestored: "आपका सेव किया ड्राफ्ट वापस मिला",
            emptyGarment: "पेंट या शर्ट का माप या नग भरें",
          },
          error: {
            shirtOrPant: "पहले शर्ट या पेंट चुनें",
          },
          pant: {
            type: {
              pant: "पेंट",
              halfRubberPant: "हाफ रबर पेंट",
              jeans: "जीन्स",
              cottonJeans: "कॉटन जीन्स",
              chudidarFartuRubber: "चूड़ीदार फरतु रबर",
            },
            options: {
              grip: "ग्रिप",
              fittingShape: "फिटिंग शेप",
              singleSilai: "सिंगल सिलाई",
              doubleSilai: "डबल सिलाई",
              hathSilai: "सांधा चीरके - हाथ सिलाई",
              moliSilai: "सांधा चीरके - मोली सिलाई",
              gajButtonChorasBelt: "गाज-बटन चौरस बेल्ट",
            },
          },
          shirt: {
            type: {
              open: "ओपन",
              bushart: "बुशर्ट",
              shortShirt: "शॉर्ट शर्ट",
              openKurto: "ओपन कुर्ता",
              kurto: "कुर्ता",
              jabbho: "झब्भा",
              safari: "सफारी",
              sherwani: "शेरवानी",
              koti: "कोटी",
              suit: "सूट",
              blazzer: "ब्लेज़र",
              indoWestern: "इंडो वेस्टर्न",
              hineckKurto: "हाई-नेक कुर्ता",
            },
            options: {
              uparPocket: "ऊपर पॉकेट",
              andarBaharPocket: "अंदर-बाहर पॉकेट",
              sadaPocket: "सादा(२) पॉकेट",
              cutPocket: "कट पॉकेट",
              uparPatti: "ऊपर पट्टी",
              chineseColar: "चाइनीज कॉलर",
              colorOneInch: "कॉलर १|| इंच",
              fancyButton: "फैंसी बटन",
              ringButton: "रिंग बटन",
              noPocket: "नो पॉकेट",
              logoTanki: "लोगो टांकी",
              pachadDarts: "पीछे डार्ट्स",
              pocket2: "पॉकेट(२) ढकनवाला",
              pocket1: "पॉकेट(१) ढकनवाला",
              gajButton: "बाय-पट्टी गाज-बटन",
              foldPatti: "फोल्ड पट्टी",
              halfBuy: "हाफ बाय",
            },
          },
        },
      },
    },
  });

export default i18n;
